import css from './index.module.scss';
import A from './components/A';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import G from './components/G';
import H from './components/H';
import I from './components/I';
import J from './components/J';
import K from './components/K';
import L from './components/L';

export default function SP220wDouble() {
    return (
        <div className={`sp-220w-double ${css['sp-220w-double']}`}>
            <A />
            <B />
            <K />
            <C />
            <D />
            <L />
            <div className="gray-box">
                <E />
                <F />
                <G />
            </div>
            <H />
            <I />
            <J />
        </div>
    );
}
